import { Dropdown, MenuProps, Avatar, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import ProfileLink from './Common/ProfileLink';

const { Text } = Typography;

const ProfileDropdown = () => {
    const navigate = useNavigate();
    const firstName = localStorage.getItem('firstName');

    const logout = () => {
        localStorage.clear();
        navigate('/giris');
    };

    const items: MenuProps['items'] = [
        {
            key: 'profile',
            label: <span onClick={() => navigate('/profile')}>Profil</span>,
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: <span onClick={logout}>Çıkış Yap</span>,
            icon: <LogoutOutlined />,
        },
    ];

    return (
        <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
            <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
                <ProfileLink></ProfileLink>
                <Text style={{fontSize: 14}}>{firstName}</Text>
            </div>
        </Dropdown>
    );
};

export default ProfileDropdown;
